import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "status-label" }
const _hoisted_2 = { class: "auction-live-date" }

import { trans } from "@/utils/trans";
  import TimerLive from "@/components/_partials/TimerLive.vue";
  import { computed, ref, watch } from "vue";
  import moment from "moment-timezone";
  import { useAuctionStore } from "@/stores/AuctionStore";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TimerLiveAuctionBegin',
  setup(__props) {

  const auctionStore = useAuctionStore();
  const auction = computed(() => auctionStore.auction);

  const timerTotalSeconds = ref<number>(0);
  const start = auction.value?.live_auction_start ? moment(auction.value.live_auction_start) : null;
  const diffSec = start ? start.diff(moment(), "seconds") : 0;
  timerTotalSeconds.value = Math.max(0, diffSec);
  const timerDays = computed(() => Math.floor(timerTotalSeconds.value / (24 * 60 * 60)));
  const timerHours = computed(() => Math.floor((timerTotalSeconds.value % (24 * 60 * 60)) / (60 * 60)));
  const timerMinutes = computed(() => Math.floor((timerTotalSeconds.value % (60 * 60)) / 60));
  const timerSeconds = computed(() => timerTotalSeconds.value % 60);

  const liveStartFormatted = computed(() => {
    const start = auction.value?.live_auction_start ? moment(auction.value.live_auction_start) : null;
    return start ? start.format("MMMM D, hh:mm A z") : "";
  });

  watch(
    () => auction.value?.live_auction_start,
    () => {
      const start = auction.value?.live_auction_start ? moment(auction.value.live_auction_start) : null;
      const diffSec = start ? start.diff(moment(), "seconds") : 0;
      timerTotalSeconds.value = Math.max(0, diffSec);
    },
    { immediate: true }
  );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(trans)("live.auction_states.before_start.title")), 1),
    _createElementVNode("div", _hoisted_2, _toDisplayString(liveStartFormatted.value), 1),
    _createVNode(TimerLive, {
      class: _normalizeClass({ warning: timerDays.value < 1 }),
      "data-days": timerDays.value,
      "data-hours": timerHours.value,
      "data-minutes": timerMinutes.value,
      "data-seconds": timerSeconds.value,
      "data-countdown": true
    }, null, 8, ["class", "data-days", "data-hours", "data-minutes", "data-seconds"])
  ], 64))
}
}

})